
export enum NightLightsStateEnum {
  CLOSE = 0,
  OPEN = 1,
}

export enum DistanceLimitStatusEnum {
  UNSET = 0,
  SET = 1,
}

export interface DistanceLimitStatus {
  state?: DistanceLimitStatusEnum;
  distance_limit?: number;
}

export enum ObstacleAvoidanceStatusEnum {
  CLOSE = 0,
  OPEN = 1,
}

export interface ObstacleAvoidance {
  horizon?: ObstacleAvoidanceStatusEnum;
  upside?: ObstacleAvoidanceStatusEnum;
  downside?: ObstacleAvoidanceStatusEnum;
}

export enum DeviceSettingKeyEnum {
  NIGHT_LIGHTS_MODE_SET = 'night_lights_state',
  HEIGHT_LIMIT_SET = 'height_limit',
  DISTANCE_LIMIT_SET = 'distance_limit_status',
  OBSTACLE_AVOIDANCE_HORIZON = 'obstacle_avoidance_horizon',
  OBSTACLE_AVOIDANCE_UPSIDE = 'obstacle_avoidance_upside',
  OBSTACLE_AVOIDANCE_DOWNSIDE = 'obstacle_avoidance_downside',
}

export type DeviceSettingType = Record<DeviceSettingKeyEnum, any>

export const initDeviceSetting = {
  [DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET]:
  {
    label: '飞行器夜航灯',
    value: '',
    trueValue: NightLightsStateEnum.CLOSE,
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,

      label: '飞行器夜航灯',
    },
    settingKey: DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET,
  },
  [DeviceSettingKeyEnum.HEIGHT_LIMIT_SET]:
  {
    label: '限高',
    value: '',
    trueValue: 120,
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,

      label: '限高',
    },
    settingKey: DeviceSettingKeyEnum.HEIGHT_LIMIT_SET,
  },
  [DeviceSettingKeyEnum.DISTANCE_LIMIT_SET]:
  {
    label: '限远',
    value: '',
    trueValue: DistanceLimitStatusEnum.UNSET,

    editable: false,
    popConfirm: {
      visible: false,
      loading: false,

      label: '限远',

    },
    settingKey: DeviceSettingKeyEnum.DISTANCE_LIMIT_SET,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON]:
  {
    label: '水平避障',
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,

    editable: false,
    popConfirm: {
      visible: false,
      loading: false,

      label: '水平避障',

    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_UPSIDE]:
  {
    label: '上视避障',
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,

    editable: false,
    popConfirm: {
      visible: false,
      loading: false,

      label: '上视避障',

    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_UPSIDE,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_DOWNSIDE]:
  {
    label: '下视避障',
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,

    editable: false,
    popConfirm: {
      visible: false,
      loading: false,

      label: '下视避障',

    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_DOWNSIDE,
  },
} as DeviceSettingType

export const initDeviceSettingFormModel = {
  nightLightsState: false,
  heightLimit: 20,
  distanceLimitStatus: { state: false, distanceLimit: 15 },
  obstacleAvoidanceHorizon: false,
  obstacleAvoidanceUpside: false,
  obstacleAvoidanceDownside: false,
}

export type DeviceSettingFormModel = typeof initDeviceSettingFormModel
